import './styles/subtitle.css'

export default function SubTitle({text='',color='#2D3958'}) {
  return (
    <div style={{color:color}} className='subtitle'>
      {text}
    </div>
  )
}
